export default function accordions() {
  const accordionWrappers = document.querySelectorAll('.accordion-wrapper');
  if (!accordionWrappers.length) return;

  const slideDown = (button, panel) => {
    button.classList.add('active');
    button.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('inert');
    panel.style.height = panel.scrollHeight + 'px';

    toggleIcons(button);

    panel.addEventListener('transitionend', function handler() {
      if (button.classList.contains('active')) panel.style.height = '';
      panel.removeEventListener('transitionend', handler);
    });
  };

  const slideUp = (button, panel) => {
    button.classList.remove('active');
    button.setAttribute('aria-expanded', 'false');
    panel.setAttribute('inert', '');
    panel.style.height = panel.scrollHeight + 'px';

    toggleIcons(button);

    setTimeout(() => {
      panel.style.height = '0px';
    }, 1);
  };

  const toggleIcons = (button) => {
    const arrow = button.querySelector('.accordion__arrow');
    const plus = button.querySelector('.accordion__plus');
    const minus = button.querySelector('.accordion__minus');

    arrow?.classList.toggle('rotate-180');
    plus?.classList.toggle('hidden');
    minus?.classList.toggle('hidden');
  };

  const closeSiblings = (button) => {
    const accordionWrapper = button.closest('.accordion-wrapper');
    const isLevel2 = button.closest('.accordion.level-2');
    let siblings;

    if (isLevel2) {
      siblings = button.closest('.accordion__panel').querySelectorAll('.accordion.level-2 .accordion__trigger');
    } else {
      siblings = accordionWrapper.querySelectorAll('.accordion.level-1 .accordion__trigger');
    }

    siblings.forEach(sibling => {
      if (sibling !== button && sibling.classList.contains('active')) {
        const panel = document.getElementById(sibling.getAttribute('aria-controls'));
        slideUp(sibling, panel);
      }
    });
  };

  Array.from(document.querySelectorAll('.accordion__trigger')).forEach(button => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));

    if (!button.classList.contains('active')) panel.style.height = '0px';

    button.addEventListener('click', () => {
      const isActive = button.classList.contains('active');

      if (!isActive) {
        slideDown(button, panel);
      } else {
        slideUp(button, panel);
      }

      closeSiblings(button);
    });
  });
}
